import loadView from "@/utils/load-view";
const routes = [
    {
        path: "/meetings",
        redirect: "/meetings/list",
        meta: {
            authRequired: true,
        },
    },
    {
        path: "/meetings/_id/:id",
        redirect: to => `/meetings/details/${to.params.id}`,
        meta: {
            authRequired: true,
        },
    },
    {
        path: "/meetings/:tab",
        name: "Meetings",
        component: loadView("Meetings"),
        props: true,
        meta: {
            authRequired: true,
            resolvers: [
                // List resolvers
                to => {
                    if (to.params.tab === "list") {
                        return { type: "meetings/meetings/getList", payload: { query: to.query } };
                    }
                    if (to.params.tab == "templates") {
                        return { type: "meetings/templates/getList" };
                    }
                },

                // Analytics resolvers
                (to, from) => {
                    // resolver should only get triggered on initial load and not when updating the url
                    // with query parameters
                    if (to.params.tab === "stats" && from.path !== "/meetings/stats") {
                        return { type: "teams/local/getList", payload: { filter: "manager" } };
                    }

                    return null;
                },
            ],
        },
        children: [
            {
                path: "/meetings/create",
                name: "MeetingsCreate",
                component: loadView("MeetingsCreate"),
                meta: {
                    modal: true,
                    authRequired: true,
                    resolvers: [
                        () => ({
                            type: "users/list/get",
                            payload: {
                                userFilter: { include: { admin: [{ _id: "directTeam" }] } },
                            },
                        }),
                        () => ({ type: "meetings/meetings/getList", payload: { query: {} } }), // load all meetings to filter out existing meetings.
                    ],
                },
            },
        ],
    },
    {
        path: "/meetings/details/:id",
        name: "MeetingsDetails",
        component: loadView("MeetingsDetails"),
        props: true,
        meta: {
            authRequired: true,
            resolvers: [
                r => ({
                    type: "meetings/meetings/getDetails",
                    payload: { _id: r.params.id },
                }),
                () => ({
                    type: "users/list/get",
                    payload: { userFilter: { include: { admin: [{ _id: "directTeam" }] } } },
                }),
            ],
        },
        children: [
            {
                path: "/meetings/details/:id/settings",
                name: "MeetingsSettings",
                component: loadView("MeetingsSettings"),
                props: true,
                meta: {
                    modal: true,
                    authRequired: true,
                },
            },
        ],
    },
];
export default routes;
